<template>
  <v-layout row wrap mb-5>
    <v-flex xs12 class="text-xs-center pages-title"><h1>{{ $t('pages.rank') }}</h1></v-flex>
    <v-flex xs12 mb-5 class="text-xs-center">
      <v-flex xs12 class="champions-head" mb-4>
        <v-layout row wrap align-center>
          <v-flex xs2>{{$t('champions.place')}}</v-flex>
          <v-flex xs4 class="text-xs-left">{{$t('champions.user')}}</v-flex>
          <v-flex xs1>x3</v-flex>
          <v-flex xs1>x1</v-flex>
          <v-flex xs2>{{$t('champions.points')}}</v-flex>
          <v-flex xs2>
            <img
                src="static/images/elei.svg"
                alt=""
                height="20"
                style="vertical-align: middle"
            >
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="champion">
        <v-layout row wrap align-center v-if="Vue.$store.state.userData.points !== 'none'">

          <v-layout align-center v-if="Object.keys(champions.you).length > 0">
            <v-flex xs2 class="place">{{champions.you.place}}</v-flex>
            <v-flex xs4 class="text-xs-left name">
              <v-avatar
                  size="50"
                  color="grey lighten-4"
              >
                <img :src="this.$store.state.userData.thumbnail" v-if="Vue.$store.state.userData.thumbnail">
              </v-avatar>
              {{Vue.$store.state.userData.firstName}} {{Vue.$store.state.userData.lastName}}
            </v-flex>
            <v-flex xs1 class="score">{{champions.you.x3}}</v-flex>
            <v-flex xs1 class="score">{{champions.you.x1}}</v-flex>
            <v-flex xs2 class="points">{{champions.you.points}}</v-flex>
            <v-flex xs2 class="points">{{champions.you.eMoney}}</v-flex>
          </v-layout>
          <v-layout align-center v-else>

            <v-flex xs2 class="place">-</v-flex>
            <v-flex xs4 class="text-xs-left name">
              <v-avatar
                  size="50"
                  color="grey lighten-4"
              >
                <img :src="this.$store.state.userData.thumbnail" v-if="Vue.$store.state.userData.thumbnail">
              </v-avatar>
              {{Vue.$store.state.userData.firstName}} {{Vue.$store.state.userData.lastName}}
            </v-flex>
            <v-flex xs1 class="score">-</v-flex>
            <v-flex xs1 class="score">-</v-flex>
            <v-flex xs2 class="points">{{Vue.$store.state.userData.points}}</v-flex>
            <v-flex xs2 class="points">{{Vue.$store.state.userData.eMoney || 0}}</v-flex>
          </v-layout>
        </v-layout>

        <v-layout row wrap align-center v-else>
          <v-flex xs12 class="text-xs-center guest-message">{{$t('champions.login')}}</v-flex>
        </v-layout>
      </v-flex>
      <v-progress-circular :size="50" indeterminate color="primary" v-if="rankLoading"></v-progress-circular>
      <v-flex xs12 v-for="champion in champions.top" :key="champion.id" :class="topClass(champion.place)" mt-3>
        <v-layout row wrap align-center>
          <v-flex xs2 class="place">{{champion.place}}</v-flex>
          <v-flex xs4 class="text-xs-left name">
            <v-avatar
              size="50"
              color="white"
            >
              <img :src="getAvatar(champion.place)">
            </v-avatar>
            {{champion.name}}
          </v-flex>
          <v-flex xs1 class="score">{{champion.x3}}</v-flex>
          <v-flex xs1 class="score">{{champion.x1}}</v-flex>
          <v-flex xs2 class="points">{{champion.points}}</v-flex>
          <v-flex xs2 class="points">{{champion.eMoney}}</v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 v-if="champions.others.length > 0">
        <virtual-list :size="40" :remain="8" class="virtual-list">
          <v-flex xs12 v-for="item in champions.others" :key="item.id" class="virtual-item">
            <v-layout row wrap align-center>
              <v-flex xs2 class="place">{{item.place}}</v-flex>
              <v-flex xs4 class="text-xs-left name">
                <v-avatar
                  size="35"
                  color="white"
                >
                  <img :src="getAvatar(item.place)">
                </v-avatar>
                {{item.name}}
              </v-flex>
              <v-flex xs1 class="score">{{item.x3}}</v-flex>
              <v-flex xs1 class="score">{{item.x1}}</v-flex>
              <v-flex xs2 class="points">{{item.points}}</v-flex>
              <v-flex xs2 class="points">{{item.eMoney}}</v-flex>
            </v-layout>
          </v-flex>
        </virtual-list>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import PagesFunc from '@/components/pages'
import Champ from '@/components/pages/champions'
import virtualList from 'vue-virtual-scroll-list'

function between (x, min, max) {
  return x >= min && x <= max
}

export default {
  name: 'UserList',
  components: {
    virtualList
  },
  data () {
    return {
      rankLoading: false,
      champions: {
        top: [],
        others: [],
        you: {}
      },
      Vue: this
    }
  },
  methods: {
    topClass (place) {
      return `champion n${place}`
    },
    getAvatar (place) {
      let avatar = {
        path: '/static/images/gifts/',
        extension: '.png'
      }
      let key = 0

      switch (true) {
        case place >= 1 && place <= 5 :
          key = place
          break
        case between(place, 6, 7):
          key = 6
          break
        case between(place, 8, 10):
          key = 8
          break
        case between(place, 11, 15):
          key = 11
          break
        case between(place, 16, 20):
          key = 16
          break
        default:
          return `/static/images/default-50x50.gif`
      }

      return avatar.path + key + avatar.extension
    }
  },
  created () {
    PagesFunc.breadcrumbsJSON(this.$router.currentRoute.path, this.$t('pages.rank'))
    Champ.loadUsers(this)
  }
}
</script>

<style scoped>
  .is-you {
    background: rgba(255, 0, 0, 0.3) !important;
    font-size: 18px;
    padding: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/champions/UserList.vue